import { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import cx from 'classnames';
import AnimateHeight, { Height } from 'react-animate-height';

import { SvgIcon } from '@/components';

import styles from './TariffsDetailsToggler.module.sass';

interface TariffsDetailsTogglerProps {
  title: string;
  isOpen?: boolean;
  children?: ReactNode;
}

const TariffsDetailsToggler: FC<TariffsDetailsTogglerProps> = ({
  isOpen = false,
  title,
  children,
}) => {
  const [isActive, setIsActive] = useState(isOpen);
  const [bodyHeight, setBodyHeight] = useState<Height>(0);

  const handleOnToggle = useCallback(() => {
    setIsActive(!isActive);
  }, [isActive]);

  useEffect(() => {
    setBodyHeight(isActive ? 'auto' : 0);
  }, [isActive]);

  const classes = cx(styles.item, {
    [`${styles['is-active']}`]: isActive,
  });

  return (
    <div className={classes}>
      <div className={styles.head} onClick={handleOnToggle}>
        <div className={styles.title}>{title}</div>
        <div className={styles.line} />
        <div className={styles.arrow}>
          <SvgIcon name="arrow-down-short" />
        </div>
      </div>

      <AnimateHeight duration={300} height={bodyHeight} animateOpacity>
        <div className={styles.body}>{children}</div>
      </AnimateHeight>
    </div>
  );
};

export default TariffsDetailsToggler;
